import { computed } from "vue";
import { useIndividStore } from "@/stores";

/**
 * Checks if verification is blocked for the current individual.
 * Verification is blocked if the individual is marked as deceased.
 */
export function useVerificationBlock() {
  const individStore = useIndividStore();
  const isVerificationBlocked = computed(() =>
    individStore.individ.isLoading ||
    individStore.verification.isAuthenticating ||
    individStore.verification.isVerified ||
    individStore.verification.showManualVerification ||
    !!individStore.individ.data?.isAvliden ||
    !!individStore.individ.data?.isAvtalatAnstalld);

  return {
    isVerificationBlocked,
  };
}
